import { useState, useEffect } from "react";
import style from "./ProfileLikedVideos.module.css";

import { useParams } from "react-router-dom";

import ProfileEmptyTab from "../profileEmptyTab/ProfileEmptyTab";
import VideoCard from "@/features/video/components/videoCard/VideoCard";
import TablePagination from "@/ui/tablePagination/TablePagination";

import { useGetUserLikedVideos } from "../../hooks/useGetUserLikedVideos";

import { useGetUserByUsername } from "@/features/auth/hooks/useGetUserByUsername";
import { useUser } from "@/features/auth/hooks/useUser";
import { useMediaQuery } from "@/hooks/useMediaQuery";

function ProfileLikedVideos() {
	const { username } = useParams();
	const { likedVideos, isPending } = useGetUserLikedVideos(username);
	const [pagination, setPagination] = useState({
		pageIndex: 0,
		pageSize: 6,
	});

	const { user, isPending: userIsPending } = useGetUserByUsername(username);
	const { user: owner, isPending: ownerIsPending } = useUser();
	const isSmallScreen = useMediaQuery("(max-width: 1100px)");

	// Auto-adjust pagination when current page becomes empty
	useEffect(() => {
		if (isPending || !likedVideos.length) return;

		const totalPages = Math.ceil(likedVideos.length / pagination.pageSize);
		if (pagination.pageIndex >= totalPages && totalPages > 0) {
			setPagination((prev) => ({
				...prev,
				pageIndex: totalPages - 1,
			}));
		}
	}, [
		likedVideos.length,
		isPending,
		pagination.pageSize,
		pagination.pageIndex,
	]);

	if (isPending && userIsPending && ownerIsPending) return <></>;

	if (!likedVideos.length && owner?.username == username)
		return (
			<ProfileEmptyTab
				title="Nemate omiljnh video."
				description="Omiljeni videi će se prikazati na ovom mjestu."
				icon="fa-heart"
			/>
		);

	if (!likedVideos.length && user?.username != owner?.username) {
		return (
			<ProfileEmptyTab
				title="Ovaj korisnik još nema nijedan omiljeni video."
				description="Omiljeni videi ovog korisnika će se pojaviti ovdje."
				icon="fa-heart"
			/>
		);
	}

	const startIndex = pagination.pageIndex * pagination.pageSize;
	const endIndex = startIndex + pagination.pageSize;
	const paginatedVideos = isSmallScreen
		? likedVideos
		: likedVideos.slice(startIndex, endIndex);

	const table = {
		getState: () => ({ pagination }),
		getRowCount: () => likedVideos.length,
		getCanPreviousPage: () => pagination.pageIndex > 0,
		getCanNextPage: () => endIndex < likedVideos.length,
		previousPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex - 1,
			})),
		nextPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex + 1,
			})),
	};

	return (
		<div className={style.holder}>
			<div className={style.grid}>
				{paginatedVideos.map((video) => (
					<VideoCard unit={video.unit} key={video.timestamp} />
				))}
			</div>
			{!isSmallScreen && likedVideos.length > pagination.pageSize && (
				<TablePagination table={table} />
			)}
		</div>
	);
}

export default ProfileLikedVideos;
